import { openShareMenu } from "../components/ShareMenu";

// Absolute production origin so shared URLs always resolve to the deployed
// site, even when triggered from the preview environment.
const SITE = "https://syndafam.com";

function absoluteOrigin() {
  // In production the user is already on syndafam.com; the browser origin is
  // fine. In preview we still want the *production* URL to travel outbound.
  if (typeof window !== "undefined") {
    const host = window.location.hostname || "";
    if (host.endsWith("syndafam.com")) return window.location.origin.replace(/\/$/, "");
  }
  return SITE;
}

// Share a payload via the SyndaFam-branded platform picker. This intentionally
// AVOIDS `navigator.share()` (the OS share sheet) — fans stay inside the site
// and choose their destination from a designed grid: X, Facebook, Messenger,
// WhatsApp, Instagram (copy + hint), iMessage/SMS, LinkedIn, Telegram, Email,
// Copy Link. Each destination opens the platform's native share URL (either
// a new tab for web platforms or a protocol handler for sms:/mailto:).
//
// `payload = { title, text, url }` — url is required, title/text are optional.
export function share(payload) {
  if (!payload || !payload.url) return;
  openShareMenu({
    title: payload.title || "SyndaFam",
    text: payload.text || payload.title || payload.url,
    url: payload.url,
  });
}

// Convenience: build a shareable track deep link. This points at the backend
// share landing (`/api/share/track/<id>`) which serves crawler-friendly og:*
// meta tags and then redirects real users to `/?track=<id>` on the SPA — the
// only way to get iMessage / WhatsApp / Discord / LinkedIn to render rich
// previews for a client-side React app.
export function trackShareUrl(trackId) {
  return `${absoluteOrigin()}/api/share/track/${encodeURIComponent(trackId)}`;
}

// Convenience: build a shareable artist profile URL (backend share landing).
export function artistShareUrl(slug) {
  return `${absoluteOrigin()}/api/share/artist/${encodeURIComponent(slug)}`;
}
